import * as action from '../../actions/lgpd/lgpdOptionsActions';
import LgpdAdvertisingViewState from '../../store/schema/LgpdAdvertisingViewState';
import saveLgpdOptionOrchestrator from '../../orchestrators/lgpd/saveLgpdOptionOrchestrator';
import { calculateCookieTargeting, setLgpdOptInBit } from 'owa-cookie-targeting';
import { getOptionsStore } from '../../store/Store';
import { orchestrator } from 'satcheljs';

orchestrator(action.toggleAllowOutlookTrackAdOption, () => {
    const store = getOptionsStore();
    const viewState = store.activeViewState as LgpdAdvertisingViewState;

    setLgpdOptInBit(viewState.optInBit);
    calculateCookieTargeting();
    saveLgpdOptionOrchestrator(store);
});
